// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div[data-v-a3e02d00]{position:absolute;top:10px;height:17px;width:20px;background-color:#f0f8ff;border-radius:10px;font-size:9pt;padding-top:3px;text-align:center;color:#fff}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
